import React, { useEffect, useState } from 'react'

import Modal from '../components/modal'
import ScreenHelpButton from '../modules/help/ScreenHelpButton'
import { useAiAssistant } from './AiAssistantContext'

const AiAssistantModal = ({ onClose, Alert }) => {
  const { enabled, saving, setEnabled } = useAiAssistant()
  const [localEnabled, setLocalEnabled] = useState(enabled)

  useEffect(() => {
    setLocalEnabled(enabled)
  }, [enabled])

  const handleSave = async () => {
    const result = await setEnabled(localEnabled)
    if (!result.ok) {
      if (Alert) {
        Alert({
          title: 'Asistente IA',
          msg: result.msg || 'No se pudo guardar la preferencia.',
          type: 'error',
        })
      }
      return
    }

    if (Alert) {
      Alert({
        title: 'Asistente IA',
        msg: localEnabled
          ? 'Asistente activado correctamente.'
          : 'Asistente desactivado. Podés volver a activarlo desde Configuración.',
        type: 'success',
        vanish: 3500,
      })
    }

    if (typeof onClose === 'function') onClose()
  }

  return (
    <Modal
      title="Asistente IA"
      modalId="ai-assistant-modal"
      modalClose={onClose}
      Alert={Alert}
      width="480px"
    >
      <div className="entity-form">
        <div className="passkeys-modal__intro-row">
          <p className="passkeys-modal-hint">
            El asistente de soporte responde preguntas sobre cómo usar Pymego.
            Podés ocultarlo cuando no lo necesites.
          </p>
          <ScreenHelpButton screenId="settings-ai-assistant" Alert={Alert} iconOnly />
        </div>

        <div className="form-field">
          <label className="form-label" htmlFor="ai-assistant-enabled">
            <input
              id="ai-assistant-enabled"
              type="checkbox"
              checked={localEnabled}
              onChange={(e) => setLocalEnabled(e.target.checked)}
              disabled={saving}
            />
            {' '}Mostrar asistente de IA
          </label>
        </div>

        {!localEnabled && (
          <p className="passkeys-modal-hint">
            Para volver a activarlo: Configuración → Asistente IA, o Valores predeterminados.
          </p>
        )}

        <div className="passkeys-modal-actions">
          <button type="button" className="modal-btn" onClick={onClose} disabled={saving}>
            Cancelar
          </button>
          <button
            type="button"
            className="modal-btn primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? 'Guardando…' : 'Guardar'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default AiAssistantModal
